export default __webpack_public_path__ + "static/media/img-6.e000eba9.jpg";